import './App.css';
import {
  Routes,
  Route,
  BrowserRouter
} from "react-router-dom";

import Layout from './layout/Layout';
import Homepage from './pages/Homepage';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import Service from './pages/Service';
import Repair from './pages/Repair';
import NewProduct from './pages/NewProduct';
import PageNotFound from './pages/PageNotFound';

function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<Layout />}>
              <Route index element={<Homepage />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="contact-us" element={<ContactUs />} />
              <Route path="repair-maintenance" element={<Repair />} />
              <Route path="technical-service" element={<Service />} />
              <Route path="new-product-sales" element={<NewProduct />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
